const {
  UtSystem,
  UtDebug,
  Live2D,
  Live2DModelWebGL,
  Live2DMotion,
  MotionQueueManager,
  PhysicsHair,
  AMotion,
  PartsDataID,
} = window as any;

export {
  UtSystem,
  UtDebug,
  Live2D,
  Live2DModelWebGL,
  Live2DMotion,
  MotionQueueManager,
  PhysicsHair,
  AMotion,
  PartsDataID,
};
